export const pointsPurchaseQueryKeys = {
  all: ['loyalty', 'points-purchase'] as const,
  offers: () => [...pointsPurchaseQueryKeys.all, 'offers'] as const,
  offersByCurrency: (currency: string) => [...pointsPurchaseQueryKeys.offers(), currency] as const,
  campaigns: () => [...pointsPurchaseQueryKeys.all, 'campaigns'] as const,
};
